import { Injectable } from '@angular/core';

export interface CanComponentDeactivate {
  canDeactivate(): boolean | Promise<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalGuardService {
  private currentGuardedComponent: CanComponentDeactivate | null = null;

  registerComponent(component: CanComponentDeactivate): void {
    this.currentGuardedComponent = component;
  }

  unregisterComponent(): void {
    this.currentGuardedComponent = null;
  }
  getCurrentComponent(): CanComponentDeactivate | null {
    return this.currentGuardedComponent;
  }

  async checkCanDeactivate(): Promise<boolean> {
    if (this.currentGuardedComponent) {
      try {
        const result = await this.currentGuardedComponent.canDeactivate();
        return result;
      } catch (error) {
        console.error('守卫检查出错:', error);
        return false;
      }
    }
    return true;
  }
}
